//
//
//
//
//
//
//
//

import pkHeader from  './header/header.vue'
import city from  './city.vue'
export default {
    components:{
        pkHeader,
        city
    },
    data() {
        return {
            title:"选择城市",
            datac:[],
            flag:"请输入中文/全拼/简拼 搜索",
        };
    },
    watch:{
        'datac':function(newValue,oldValue){
          //  console.log(newValue)
        }
    },
    methods:{
        onShortcutTouchStart(){
            event.preventDefault()
        }
    },
    mounted(){
        var back =  decodeURIComponent(this.$until.getUrlParam('back'));
        let flas = this.$until.getUrlParam('stag') == 'start' ? "findAirportCities" : ((back.indexOf("from") != -1||(this.$until.getUrlParam("from")&&this.$until.getUrlParam("from")!=='null'))? "queryAirPortOpenCity":"queryStationOpenCity")
        if(back.indexOf('giveawayAircraft') != -1){
            flas = 'queryAirPortSite';
            this.flag =  "请输入机场名字";
        }
        //console.log("flas", flas);
        let data = {};
        if(flas === 'queryStationOpenCity' || flas === 'queryAirPortSite'){
            data['channelCode'] = localStorage.getItem('useCar_jb_channelCode')
        }
        this.$http.post(window.innerAPI + "?server=" + flas,data).then(res =>{
            this.datac = res.data.data.data
            //console.log(this.datac)
        })
    }
};



// WEBPACK FOOTER //
// ./src/components/common/posi.vue